// Entry point for the build script in your package.json
// jQueryはjquery-shim.jsでグローバルに設定済み

import * as bootstrap from "bootstrap"
// Make Bootstrap available globally
window.bootstrap = bootstrap

// Import Font Awesome
import '@fortawesome/fontawesome-free/js/all'

// SortableJS for drag and drop sorting
import Sortable from 'sortablejs'
window.Sortable = Sortable

// Flatpickr for date picker
import flatpickr from "flatpickr"
import "flatpickr/dist/l10n/ja.js"
window.flatpickr = flatpickr

// Tom Select for enhanced select boxes
import TomSelect from 'tom-select'
window.TomSelect = TomSelect

// Other libraries
import "jquery.scrollto"

// Import Turbo
import "@hotwired/turbo-rails"

// Function to initialize Bootstrap components
function initializeBootstrapComponents(container = document) {
  // Initialize all dropdowns
  const dropdownElementList = container.querySelectorAll('.dropdown-toggle')
  const dropdownList = [...dropdownElementList].map(dropdownToggleEl => {
    // Avoid re-initializing already initialized dropdowns
    if (!bootstrap.Dropdown.getInstance(dropdownToggleEl)) {
      return new bootstrap.Dropdown(dropdownToggleEl)
    }
  })
  
  // Initialize all alerts
  const alertList = container.querySelectorAll('.alert')
  const alertInstanceList = [...alertList].map(element => {
    if (!bootstrap.Alert.getInstance(element)) {
      return new bootstrap.Alert(element)
    }
  })
  
  // Initialize all collapses
  const collapseElementList = container.querySelectorAll('.collapse')
  const collapseList = [...collapseElementList].map(collapseEl => {
    if (!bootstrap.Collapse.getInstance(collapseEl)) {
      return new bootstrap.Collapse(collapseEl, { toggle: false })
    }
  })
}

// Initialize Bootstrap components on page load and Turbo navigation
document.addEventListener('turbo:load', () => {
  initializeBootstrapComponents()
})

// Re-initialize Bootstrap components after Turbo Stream updates
document.addEventListener('turbo:render', () => {
  initializeBootstrapComponents()
})

// Import custom JavaScript files
import "./lib/initialize"
import "./lib/table_sort"
import "./lib/article"
import "./lib/manage/articles"
import "./lib/manage/edit_item"
import "./lib/manage/meetings"
